import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { ThemeContext } from 'styled-components';
import WithActions from './WithActions';
import IconCheck from '../../../../assets/Images/Icons/IconCheck';

/**
 * Reusable component for displaying disabled/success state in forms
 * Shows a success checkmark icon with a message indicating the form is verified/completed
 * 
 * @param {string} message - The message to display (e.g., "Verified", "Email Verified", "Account Created")
 * @param {string} tooltip - Optional tooltip for the success button (defaults to "Added")
 * @param {string} textColor - Optional text color override (defaults to theme.colors.brandSecondary)
 */
const DisabledFormState = ({ 
    message, 
    tooltip = "Added",
    textColor 
}) => {
    const theme = useContext(ThemeContext);
    const color = textColor || theme.colors.brandSecondary || theme.colors.secondary;

    return (
        <WithActions
            forceSpacing
            showSuccessButton={true}
            successTooltip={tooltip}
            successIcon={IconCheck}
            successColor={theme.colors.success}
            inputType="text"
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    margin: '10px 0',
                    width: '100%',
                }}
            >
                <Typography variant="h5" sx={{ color, textAlign: 'left', width: '100%' }}>
                    {message}
                </Typography>
            </Box>
        </WithActions>
    );
};

export default DisabledFormState;
